import(/* webpackMode: "eager", webpackExports: ["CasinosCatalog"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/casinos/CasinosCatalog.tsx");
